import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import { selectCartRemainingTime } from '../../selectors';
import { deleteCartTickets, setCartRemainingTime } from '../../actions';

function OrderCountdown() {
    const dispatch = useDispatch();
    const [intervalId, setIntervalId] = useState(null);
    const [remainingTime, setRemainingTime] = useState(useSelector(selectCartRemainingTime));

    const updateCountdown = () => {
        const currentTime = Math.floor(Date.now() / 1000);
        const timeDifference = reservationEndTime - currentTime;

        if (timeDifference <= 0) {
            clearInterval(intervalId);
            dispatch(setCartRemainingTime(0));
            dispatch(deleteCartTickets());
        } else {
            setRemainingTime(timeDifference);
        }
    };

    useEffect(() => {
        const id = setInterval(updateCountdown, 1000);
        setIntervalId(id);
        return () => clearInterval(id);
    }, []);

    const reservationEndTime = Math.floor(Date.now() / 1000) + remainingTime;
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;
    const addLeadingZero = (value) => (value < 10 ? `0${value}` : value);

    return (
        <div className="countdown">
            <Spinner animation="border" variant="primary" />
            {addLeadingZero(minutes)}:{addLeadingZero(seconds)}
        </div>
    );
}

export default OrderCountdown;
